/* Helper function to throttle scroll events function */
export const throttle = function (fn, wait) {
  var time = Date.now();

  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};

// Replace fake src attributes for real 'src' attribute and load video
export function videoLoad($video) {
  if (breakpointAtLeast('medium')) {
    var $videoSrc = $video.find('source');
    var $src = $videoSrc.data('src');

    // Set proper src attribute
    $videoSrc.attr('src', $src);

    // Load and play video
    $video.get(0).load();
    // $video.get(0).play();
  }
}

export const breakpoints = {
  xsmall: 0,
  small: '480px',
  medium: '740px',
  large: '1024px',
  xlarge: '1200px',
  xxlarge: '1560px',
  fhd: '1920px',
  qhd: '2560px',
};

export function breakpointAtLeast(size) {
  return window.matchMedia(`(min-width: ${breakpoints[size]})`).matches;
}

export function breakpointUpTo(size) {
  return window.matchMedia(`(max-width: ${breakpoints[size]})`).matches;
}
